import 'store/bolt/gallery.js';
import { accessNested } from 'utils/utils';
import Store from 'store/store';

const store = Store.get();
const hasMiniGallery = accessNested(store, 'appData.options.paramountFeatures.toutCarousel.contentCarousel', false);

if (!store.gallery && hasMiniGallery) {
	store.set({ gallery: {}});
}